/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_Archiving_JobInputs */



/**
* | output |
* | --- |
* | "Error archiving job: {error}" |
*
* @param {Error_Archiving_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_archiving_job = /** @type {((inputs: Error_Archiving_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Archiving_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de l’archivage de la tâche : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Archivierungsauftrag: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante l'archiviazione del lavoro: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при архивировании задания: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al archivar el trabajo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`归档作业出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`アーカイブジョブ中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आर्काइविंग जॉब में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao arquivar tarefa: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error archiving job: ${i?.error}`)
});